(function () {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  // category click handlers, doesn't make sense to put in FilterPopup or make a whole new class just for these
  (function () {
    document.querySelectorAll('[data-category-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        document.querySelector('[data-collection-content]').classList.add('loading'); // no data-attr here, 

        document.querySelector('.loading-logo.filter-logo').classList.remove("hidden"); // preserve sort_by and non-category filters, if present

        var sort = new URLSearchParams(window.location.search).get('sort_by');
        var filters = new URLSearchParams(window.location.search);

        if (sort) {
          filters.set('sort_by', sort);
        }

        if (filters.get('filter.p.m.custom.categories')) {
          filters.delete('filter.p.m.custom.categories');
        } // only set category filter if it's not all, otherwise just leave it deleted


        var newCategory = link.getAttribute('data-category-link');

        if (newCategory != 'All') {
          filters.set('filter.p.m.custom.categories', newCategory);
        }

        var newUrl = new URL(window.location.origin + window.location.pathname);
        newUrl.search = new URLSearchParams(filters).toString();
        window.location.href = newUrl.toString();
      });
    });
  })();

  var FilterPopup = /*#__PURE__*/function () {
    function FilterPopup() {
      var _this = this;

      _classCallCheck(this, FilterPopup);

      this.pageContent = document.querySelector('[data-collection-content]');
      this.root = document.querySelector('[data-collection-filter-popup]');
      this.content = this.root.querySelector('[data-collection-filter-popup-content]');
      this.newUrl = new URL(window.location.href);
      this.checkedInputs = this.root.querySelectorAll("input:checked"); // filter triggers

      document.querySelectorAll("[data-filter-popup-trigger]").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          _this.open();
        });
      }); // close on click outside only

      this.root.addEventListener("click", this.close.bind(this));
      this.content.addEventListener("click", function (e) {
        e.stopPropagation();
      }); // button handlers

      this.closeButton = this.root.querySelector('[data-filter-popup-close]');
      this.closeButton.addEventListener("click", this.close.bind(this));
      this.cancelButton = this.root.querySelector('[data-filter-popup-cancel]');
      this.cancelButton.addEventListener("click", this.close.bind(this));
      this.applyButton = this.root.querySelector('[data-filter-popup-apply]');
      this.applyButton.addEventListener("click", this.apply.bind(this));
      this.clearButton = document.querySelector('[data-filter-popup-clear]');
      this.clearButton.addEventListener("click", this.clearFilters.bind(this)); // end of button handlers
      // checkbox update stored URL for apply button

      this.root.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('click', function () {
          if (input.checked) {
            _this.newUrl.searchParams.set(input.getAttribute('data-param-name'), input.getAttribute('data-param-value'));
          } else {
            _this.newUrl.searchParams.delete(input.getAttribute('data-param-name'), input.getAttribute('data-param-value'));
          }
        });
      });
      this.setupSortSelects();
    }

    _createClass(FilterPopup, [{
      key: "setupSortSelects",
      value: function setupSortSelects() {
        var _this2 = this;

        document.querySelectorAll('[data-sort-select]').forEach(function (el) {
          el.addEventListener('change', function (e) {
            _this2.showLoadingOverlay();

            var selected = e.target.value;
            var newSearchParams = new URLSearchParams(window.location.search);
            newSearchParams.set('sort_by', selected);
            window.location.href = window.location.pathname + '?' + newSearchParams.toString();
          });
        });
      }
    }, {
      key: "open",
      value: function open() {
        this.checkedInputs.forEach(function (input) {
          input.checked = true;
        });
        this.root.classList.add('visible');
      }
    }, {
      key: "close",
      value: function close() {
        this.root.classList.remove('visible');
      }
    }, {
      key: "apply",
      value: function apply() {
        this.close();
        this.showLoadingOverlay();
        window.location.href = this.newUrl.toString();
      }
    }, {
      key: "clearFilters",
      value: function clearFilters() {
        // preserve sort_by and category filters, if present
        var sort = this.newUrl.searchParams.get('sort_by');
        var category = this.newUrl.searchParams.get('filter.p.m.custom.categories');
        this.newUrl = new URL(window.location.origin + window.location.pathname);

        if (sort) {
          this.newUrl.searchParams.set('sort_by', sort);
        }

        if (category) {
          this.newUrl.searchParams.set('filter.p.m.custom.categories', category);
        }

        this.showLoadingOverlay();
        window.location.href = this.newUrl.toString();
      }
    }, {
      key: "showLoadingOverlay",
      value: function showLoadingOverlay() {
        this.pageContent.classList.add("loading");
        document.querySelector('.loading-logo.filter-logo').classList.remove('hidden');
      }
    }, {
      key: "hideLoadingOverlay",
      value: function hideLoadingOverlay() {
        this.pageContent.classList.remove("loading");
        document.querySelector('.loading-logo.filter-logo').classList.add('hidden');
      }
    }]);

    return FilterPopup;
  }();

  window.filterPopup = new FilterPopup();

})();
